module.exports = __webpack_public_path__ + "img/2024-05_commencement.ccf9d235.jpg";